import type { FaireProductEntity } from "../../entity_types/product";

export const p_cyxfedmdyf: FaireProductEntity = {
  token: "p_cyxfedmdyf",
  type: "product",
  name: "LM-SW-1016 Pink/Light Pink Pray Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/d75b0ffa24b87021577c80d4d7e885b1fdbc9e717b08c55672e09e376a60d35c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d0f227862c08b418eafff9631474f9890ac5c75591cfdc4dbc0ac93452b2bd2.jpeg"
  ],
  priceDollars: 24.5,
  description: "Soft, comfortable sweatshirt showcasing \"Pray\" in bold puff lettering across the chest. Available in a variety of colorways to express your personal style. A versatile essential that pairs perfectly with any outfit while making a gentle, meaningful statement.\n\n50% cotton 50% polyester\n",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:12.147Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
